import React from "react";
import StarIcon from "@mui/icons-material/Star";
import { IconButton } from "@mui/material";
import StarOutlineRoundedIcon from "@mui/icons-material/StarOutlineRounded";
import StarRoundedIcon from "@mui/icons-material/StarRounded";

interface FavoriteStarProps {
  checked: boolean;
  onClick?: () => void;
  width?: string;
  height?: string;
}

const FavoriteStar: React.FC<FavoriteStarProps> = ({
  checked,
  onClick,
  width = "30px",
  height = "30px",
}) => {
  return (
    <IconButton
      onClick={onClick}
      style={{
        backgroundColor: "transparent",
        borderRadius: "50%",
        transition: "background-color 0.3s ease",
      }}
    >
      {checked ? (
        <StarRoundedIcon
          style={{
            color: "#A5EB17",
            width: width,
            height: height,
          }}
        />
      ) : (
        <StarOutlineRoundedIcon
          style={{
            color: "#000000",
            width: width,
            height: height,
          }}
        />
      )}
    </IconButton>
  );
};

export default FavoriteStar;
